export const selectTemplates = (state) => state.templates;
export const selectTemplatesTotal = (state) => state.total;
